<template>
  <BaseLayout @click-back="back" isFunction="true" hasBottomButton="true" hasHeaderBar="true">
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">請購單號</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.requestNoStart" />

      <div class="input-group-prepend">
        <div class="input-group-text">~</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.requestNoEnd" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">需求日期</div>
      </div>
      <input type="date" class="form-control" v-model="searchData.requestDateStart" />
      <div class="input-group-prepend">
        <div class="input-group-text">~</div>
      </div>
      <input type="date" class="form-control" v-model="searchData.requestDateEnd" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">請購部門</div>
      </div>
      <input v-model="searchData.applyDepartment" type="text" class="form-control" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">請購日期</div>
      </div>
      <input v-model="searchData.applyDate" type="date" class="form-control" />
    </div>
    <div class="list-group" style="text-align: left;">
      <template v-for="(form,index) in gridData">
        <div :key="form.PurchaseRequestNo" class="list-group-item list-group-item-action">
          <div
            class="d-flex w-100 justify-content-between"
            style=" background:#EEE; padding: 5px 5px 0px 5px"
          >
            <b class="mb-1">
              <!-- <i class="fas fa-building"></i> -->
              單號: {{form.PurchaseRequestNo}}
            </b>
            <h5
              class="badge badge-success"
              style="width:50%; 
              overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
     word-break: break-all;"
            >
              <span style="font-size:1rem;font-weight: 400;">{{form.Department}}</span>
            </h5>
          </div>
          <div class="d-flex flex-row">
            <p class="mb-1 w-100" style="backgroun-color:#EEE;  word-break: break-all;">
              <span class="badge badge-light">請購日:{{form.ApplyDate}}</span>
              <span class="badge badge-light">需求日:{{form.RequestDate}}</span>
            </p>
          </div>
          <div class="d-flex flex-row">
            <span class="badge badge-primary">核准日:{{form.ApproveDate}}</span>
          </div>

          <small v-if="form.Supplier" style="color:#888;float:right;">供應商: {{form.Supplier}}</small>
          <!-- <small style="float:right; color:#888;">
            <i class="fas fa-user"></i>
            {{form.EmployeeName}}
          </small>-->
        </div>
      </template>
    </div>
    <button @click="getData" type="button" class="btn-xl btn btn-primary btn-circle">
      <i class="fas fa-search"></i>
    </button>
  </BaseLayout>
</template>
<script>
export default {
  name: "PurchaseRequestQuery",
  data: function() {
    return {
      searchData: {
        companyId: this.$store.state.companyId,
        requestNoStart: "",
        requestNoEnd: "",
        requestDateStart: (function() {
          var x = new Date();
          x.setMonth(x.getMonth() - 1);
          return x.toISOString().slice(0, 10);
        })(), // new Date().toISOString().slice(0, 10),
        requestDateEnd: new Date().toISOString().slice(0, 10),
        applyDepartment: "",
        applyDate: null //new Date().toISOString().slice(0, 10)
      },
      gridData: [],
      autocomplete: {
        requestNoStart: [],
        requestNoEnd: [],
        applyDepartment: []
      }
    };
  },
  methods: {
    back: function() {
      this.$router.go(-1);
    },
    getData: function() {
      var _this = this;
      this.startLoad();
      _this.$http
        .post("/WebApp/PurchaseRequestQuery/GetData", {
          ...this.searchData
        })
        .then(res => {
          _this.gridData = res.data;
          _this.gridData.forEach(v => {
            let setDate = dateName => {
              if (v[dateName]) {
                var d = new Date(parseInt(v[dateName].substr(6)));
                v[dateName] =
                  d.getFullYear() +
                  "-" +
                  (d.getMonth() + 1) +
                  "-" +
                  d.getDate();
              }
            };
            setDate("ApplyDate");
            setDate("RequestDate");
            setDate("ApproveDate");
          });
          _this.endLoad();
        })
        .catch(err => {
          _this.endLoad();
        });
    },
    getPurchaseRequestNoAuto: function(term, target) {
      var _this = this;
      _this.$http
        .post("/WebApp/PurchaseRequestQuery/GetPurchaseRequestNoAuto", {
          companyId: this.companyId,
          term: term
        })
        .then(res => {
          target = res.data;
        });
    },
    getApplyDepartmentAuto: function(term) {
      var _this = this;
      _this.$http
        .post("/WebApp/PurchaseRequestQuery/GetApplyDepartmentAuto", {
          companyId: this.companyId,
          term: term
        })
        .then(res => {
          _this.autocomplete.applyDepartment = res.data;
        });
    }
  },
  mounted: function() {}
};
</script>
<style lange="scss" scoped>
.btn-circle.btn-xl {
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}
input[type="date"] {
  padding: 0;
}
</style>